// DS: C60
import React from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import Button from '../../../../Button';
import { ThemeOptions, ThemeOverride, } from '@wix/da-react-context/pkg/ThemeContext';
import PremiumAssetList from '../../../../PremiumAssetList';
import { BiEventType } from '../../../../biLogger/constants';
import DownloadOptions from './DownloadOptions';
import { useDownloadType, DownloadType } from './utils';
import ddt from '@wix/da-ddt';
import s from './FreeAndPcpPopover.scss';
// TODO: there is a lot of overlap here with the PcpPopover, should probably make
// these two components reuse as much as possible
var FreeAndPcpPopover = function (_a) {
    var _b, _c;
    var deviation = _a.deviation, _d = _a.deviation, deviationId = _d.deviationId, _e = _d.extended, _f = _e === void 0 ? {} : _e, pcp = _f.pcp, download = _f.download, _g = _a.closeTooltip, closeTooltip = _g === void 0 ? function () { return null; } : _g, onDownload = _a.onDownload;
    var _h = useDownloadType(DownloadType.FREE), selectedType = _h.selectedType, setSelectedType = _h.setSelectedType;
    var t = useTranslation().t;
    // We're only showing this popup if premium content exists, so it's bad if we make it here.
    if (!pcp) {
        ddt.alert('pcp', 'Showing the FreeAndPcpPopover while the pcp field on the relevant deviation is undefined. This should not happen.', ['pcp', 'download'], { deviation: deviation });
        return null;
    }
    var downloadUrl = selectedType === DownloadType.FREE
        ? download && download.url
        : selectedType === DownloadType.PREMIUM
            ? (pcp.hasUserPurchased && pcp.url) || undefined
            : undefined;
    var handleClick = function (e) {
        if (downloadUrl) {
            onDownload && onDownload();
        }
        closeTooltip(e);
    };
    var checkoutUrl = ((_b = deviation.pcp) === null || _b === void 0 ? void 0 : _b.subproductId) ? Url.checkoutLink((_c = deviation.pcp) === null || _c === void 0 ? void 0 : _c.subproductId)
        : undefined;
    return (React.createElement("div", { className: s['root'] },
        React.createElement(ThemeOverride, { theme: ThemeOptions.LIGHT },
            React.createElement("div", null,
                React.createElement("div", { className: s['title'] }, t('pcp.downloadDeviation')),
                React.createElement(DownloadOptions, { deviation: deviation, pcp: pcp, download: download, selectedType: selectedType, onSelect: setSelectedType })),
            React.createElement("div", null,
                React.createElement(PremiumAssetList, { assets: pcp.assets, muted: selectedType === DownloadType.FREE }),
                React.createElement(Button, { view: "b18", className: s['download-button'], onClick: handleClick, href: downloadUrl || checkoutUrl, biData: {
                        evid: BiEventType.DOWNLOAD_NOW_CLICK,
                        deviationid: deviationId,
                    }, disabled: selectedType === undefined }, t('pcp.downloadNow'))))));
};
FreeAndPcpPopover.displayName = 'FreeAndPcpPopover';
export default FreeAndPcpPopover;
//# sourceMappingURL=FreeAndPcpPopover.js.map